import api from 'configs/api';

const endpointUrl = 'attachment';

export const getAttachmentByPath = async ({ path }) => {
  const preSignedURL = `/${endpointUrl}/${path}`;
  const { data } = (await api.get(preSignedURL)).data;

  return data;
};

export const getImageAsBase64FromS3 = async ({ path }) => {
  const { data } = await api.get(`${endpointUrl}/image/${path}`);
  return data;
};
